var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.201,
    d: "M12 12.41a4.556 4.556 0 0 0 4.555-4.555A4.556 4.556 0 0 0 12 3.3a4.556 4.556 0 0 0-4.555 4.555A4.556 4.556 0 0 0 12 12.41M20.65 20.7v-1.995a4.22 4.22 0 0 0-1.266-3.006 4.37 4.37 0 0 0-3.061-1.248s-1.594.91-4.327.91-4.327-.91-4.327-.91a4.36 4.36 0 0 0-3.061 1.248 4.2 4.2 0 0 0-1.266 3.006V20.7z"
  })));
};
export default SvgUser;